<footer>
  <p>
    © {{currentYear}} Huron Consulting Group Inc. and affiliates. All rights reserved.<br />
    <a href="https://www.huronconsultinggroup.com/legal/privacy-statement" class="link-style" target="_blank" rel="noopener noreferrer">Privacy Statement</a> | <a href="https://www.huronconsultinggroup.com/legal/cookies-policy" class="link-style" target="_blank" rel="noopener noreferrer">Cookie Policy</a>
  </p>
</footer>
